import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetCustomerActivities(id: string | undefined) {
  return useQuery(queries.customers.getCustomerActivitiesById(id || ''))
}
